import { render, staticRenderFns } from "./card3.vue?vue&type=template&id=52853fae&scoped=true&"
import script from "./card3.vue?vue&type=script&lang=js&"
export * from "./card3.vue?vue&type=script&lang=js&"
import style0 from "./card3.vue?vue&type=style&index=0&id=52853fae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52853fae",
  null
  
)

export default component.exports